
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as indexk9o_A2E1VuJu_45RZ7_45H3BogOmbgvsNl6FThZs3Lv_tOsMeta } from "/opt/buildhome/repo/pages/messages/index.vue?macro=true";
import { default as _91guid_934GZwUqFKjVaK7nNuc5EcEtHJhTNYginw7bOT1vt_45jsMMeta } from "/opt/buildhome/repo/pages/messages/[guid].vue?macro=true";
import { default as messages3maGN6BtljYJ_4amUi4sXfRWex8Foh_4597x3RpUnzsHsMeta } from "/opt/buildhome/repo/pages/messages.vue?macro=true";
import { default as _91_46_46_46slug_93kxjr4BRGYu8PjICw6eKIYYGNlIv1T0FK9GFhjf_45hT6QMeta } from "/opt/buildhome/repo/pages/[...slug].vue?macro=true";
import { default as leads06bkVTgXheh8DVjxBgcITbSDOOvHMRxnb1MEeKCGbZkMeta } from "/opt/buildhome/repo/pages/crm/leads.vue?macro=true";
import { default as dashboardAD_451mrT_EUTWtWLxQnqVQ_45hCD6MuBiMzQsV5qGLZFZMMeta } from "/opt/buildhome/repo/pages/dashboard.vue?macro=true";
import { default as indexhEy48mU3Z1Lyuo9pLFhrQXhsWs1CnSz3lnm_45_zRS7K8Meta } from "/opt/buildhome/repo/pages/task/index.vue?macro=true";
import { default as indexRDDwOWQKD3DA_45mVK6A0RJzvjotOY9_45Abw5KHKjB8KCUMeta } from "/opt/buildhome/repo/pages/visibility/index.vue?macro=true";
import { default as my_45page4dWMF93RumT_p8baNRq8sUygrsI82H1zKIxWcc9NC60Meta } from "/opt/buildhome/repo/pages/visibility/my-page.vue?macro=true";
import { default as reviewsCkMpUn55CVvaHC31PexZ68stN0x3eIIbnEAHadSS1mQMeta } from "/opt/buildhome/repo/pages/visibility/reviews.vue?macro=true";
import { default as sectorsBlB_sAl_45G9u5gv8gvl1JeiTJZUaN6ebedg7EV_VwAtoMeta } from "/opt/buildhome/repo/pages/visibility/sectors.vue?macro=true";
import { default as statisticsqntr5uXU3_uH012mROFzOB6pMhfuDF8m7N78DbmYzpMMeta } from "/opt/buildhome/repo/pages/visibility/statistics.vue?macro=true";
import { default as indexWjIokpahI5FBqAWh3ezNYfdpAsy3S67MkLrZ8jBLaNUMeta } from "/opt/buildhome/repo/pages/visibility/photos/index.vue?macro=true";
import { default as createtcK0O6pL6Ugzyw9MfSMsGVSCh5jPi2lQN_HXIUAfQoIMeta } from "/opt/buildhome/repo/pages/visibility/photos/create.vue?macro=true";
import { default as _91albumId_93dO1bWrv4mfyTGWYy5AyZgzRz10SCu7LXOOh439IQIAQMeta } from "/opt/buildhome/repo/pages/visibility/photos/[albumId].vue?macro=true";
import { default as visibilityZhXWbhT8e55VG__45P2ZF3n_mg6sRTHSDf3Q8Z1cOE8aEMeta } from "/opt/buildhome/repo/pages/visibility.vue?macro=true";
import { default as logoutgU_G4QHH66XaZEr3gUo0k9EyXTJMADGobsXma60gyPwMeta } from "/opt/buildhome/repo/pages/auth/logout.vue?macro=true";
import { default as _91id_938T3BGYjJZTfSEvAPkrcx4DKIbH5Rd3_45ubaozTyRUCDsMeta } from "/opt/buildhome/repo/pages/contacts/[id].vue?macro=true";
import { default as switch_45tenantgM0tmPXBKnUjcBjVpSFzrrTuCkTcwSc8o8GgyNIb8OcMeta } from "/opt/buildhome/repo/pages/switch-tenant.vue?macro=true";
import { default as index0dTUHAQ2bqHyw4NLIrSYpoisNcSwixZtysVWSvJbO_wMeta } from "/opt/buildhome/repo/pages/contacts/index.vue?macro=true";
import { default as activitiesIgSA_459OwtkXfGcSLGK4xU8Eo7h3fUgHlp0GttCnbEgcMeta } from "/opt/buildhome/repo/pages/crm/activities.vue?macro=true";
import { default as indexsIiqcEui9Dm7_45oiCC3acHgU7xRmkxrLlSvWzG6RztrcMeta } from "/opt/buildhome/repo/pages/planning/index.vue?macro=true";
import { default as indexh1PrRKZG8_8_6scIIyl4vp1aLQzchrfNNtbXbG6vutsMeta } from "/opt/buildhome/repo/pages/redirect/index.vue?macro=true";
import { default as indexTDY4ecMxSocMg8JoVZBqOgLXFHk3gt1jav_48Qd2NS0Meta } from "/opt/buildhome/repo/pages/worksite/index.vue?macro=true";
import { default as indexvzNR8oKITOsXvh0bFvN4sQPZ3aZfPJ2MbVSOkak0iwAMeta } from "/opt/buildhome/repo/pages/invoicing/index.vue?macro=true";
import { default as signed_45documentwdpDjwf8Pb8wZLMRED21cdhlMWLA_45WBInJPUglSFuNcMeta } from "/opt/buildhome/repo/pages/signed-document.vue?macro=true";
import { default as index0mOV_ExATN_5_45wqIgxkOUkFVIlw9MwDGfqacXlLfMpIMeta } from "/opt/buildhome/repo/pages/timesheet/index.vue?macro=true";
import { default as impersonateuLIcDh3kVFBP2YkKQMGULPrEgRWRI_lnwO0lBxt9RlEMeta } from "/opt/buildhome/repo/pages/auth/impersonate.vue?macro=true";
import { default as indexFICVtqk7yTzTpWZ9NuaoKj_45X5r8ObsEsnjQKwEXgNQcMeta } from "/opt/buildhome/repo/pages/auth/login/index.vue?macro=true";
import { default as errorvAgMiQYAow3TVYSdshmNbyy8S9zqYb4KOSqYzF1_SsIMeta } from "/opt/buildhome/repo/pages/auth/tenant/error.vue?macro=true";
import { default as indexsggCDSKVUt2dNjVWZ3Vj3vJb1KMkHItzaNb7sLjq7LoMeta } from "/opt/buildhome/repo/pages/worksite/planning/index.vue?macro=true";
import { default as worksiteRpfs_45ey9beGINLy7Ao9OOnti6mGikuPpUGsps3qiUWMMeta } from "/opt/buildhome/repo/pages/worksite/planning/worksite.vue?macro=true";
import { default as planningum97mRNgeZMXtzEOGZxE_45VZat1vAX9WctBk3_ZvWOJQMeta } from "/opt/buildhome/repo/pages/worksite/planning.vue?macro=true";
import { default as index2NDfaipAjms7dHgNfrfxvv4UP6KVCs4XMzPQC0k9dHEMeta } from "/opt/buildhome/repo/pages/invoicing/settings/index.vue?macro=true";
import { default as peppolt4TBE65eibwkPxRORzcTQmYi5_45fMeAVrRDS1UDpuI5oMeta } from "/opt/buildhome/repo/pages/invoicing/settings/peppol.vue?macro=true";
import { default as indexNHgSU4dqPhuafbqKSDvBAkcNr_45tUdg9_45vlAhQPUqYjYMeta } from "/opt/buildhome/repo/pages/invoicing/settings/documents/index.vue?macro=true";
import { default as quotesale7n6r1K_45AgMSgVJv8L0YqWqd8iHgC6eQ0Rb6_45NOvMMeta } from "/opt/buildhome/repo/pages/invoicing/settings/documents/quotes.vue?macro=true";
import { default as invoices6as1egWYSWJLqXWgoPPLrqlxWz5GZlyDr17r2mkwCuYMeta } from "/opt/buildhome/repo/pages/invoicing/settings/documents/invoices.vue?macro=true";
import { default as annex_45pdfL3M6S8DAdbmG3Xh7AcvXiBY2HAeBRStahbCOtj2DFuUMeta } from "/opt/buildhome/repo/pages/invoicing/settings/documents/annex-pdf.vue?macro=true";
import { default as order_45slips5ZdKy8e4afxIQPOXLzVI8RrJALM_45btSbzw9BIbhEbfsMeta } from "/opt/buildhome/repo/pages/invoicing/settings/documents/order-slips.vue?macro=true";
import { default as credit_45notespVYqjuTBYu7QizAbiCiSKsLQtw9xbrkI9X7GH4_UYmIMeta } from "/opt/buildhome/repo/pages/invoicing/settings/documents/credit-notes.vue?macro=true";
import { default as delivery_45slipsSLZm8fsDuM4QiGqMYWGdlDXV3NS7aSk4V_455DL3A_45tooMeta } from "/opt/buildhome/repo/pages/invoicing/settings/documents/delivery-slips.vue?macro=true";
import { default as documentsx5YRiB3yIr3utKcalBqHbidJBsxQDfjFJ4Waglxldw0Meta } from "/opt/buildhome/repo/pages/invoicing/settings/documents.vue?macro=true";
import { default as templatesqMc11oTBsypUQxNXnOhoDZcXJQVnpTe_TlxSSlp5_NkMeta } from "/opt/buildhome/repo/pages/invoicing/settings/templates.vue?macro=true";
import { default as indexU7mXe2Mpc_45NXS9bFCY_msTcHPklAJpg0Ga_vi8fRkagMeta } from "/opt/buildhome/repo/pages/invoicing/settings/export/index.vue?macro=true";
import { default as indexCbC356F1llzNkCh9dmDOYyUxLBvAbxl_45SM_C02v10uIMeta } from "/opt/buildhome/repo/pages/invoicing/settings/import/index.vue?macro=true";
import { default as indexNeL9F7_JBG8MrEP89B_2JHbzTj_45Y_f46RRE8sZCx6b0Meta } from "/opt/buildhome/repo/pages/invoicing/settings/notifications/index.vue?macro=true";
import { default as documents0A1Qge66ne7x2SZeTTm2CpzVZ0hE5FKhsru_E9NUNh8Meta } from "/opt/buildhome/repo/pages/invoicing/settings/notifications/documents.vue?macro=true";
import { default as payment_45remindersy9ptJrTQDc8485LRAS5SawqfQpuFMdI2ZxOnScmjuoUMeta } from "/opt/buildhome/repo/pages/invoicing/settings/notifications/payment-reminders.vue?macro=true";
import { default as payment_45reminder_45groupsrHQkmqS1UoQOoo6AN0ltwI_k_45wsEVe9OesHuc7nafEkMeta } from "/opt/buildhome/repo/pages/invoicing/settings/notifications/payment-reminder-groups.vue?macro=true";
import { default as notifications_RN4qi7ta6CwEh_5LDncWgFl32o_WFfiAXn_45YwpCBiUMeta } from "/opt/buildhome/repo/pages/invoicing/settings/notifications.vue?macro=true";
import { default as documents4gq_45_41AVY_ZLsaLWHdWIH7wNuAgmgYg0h6WImiqd9AMeta } from "/opt/buildhome/repo/pages/invoicing/settings/export/documents.vue?macro=true";
import { default as documentsnWYISnzhTJcexaHl4du44KUFJnnctwbXx9rggLDs66MMeta } from "/opt/buildhome/repo/pages/invoicing/settings/import/documents.vue?macro=true";
import { default as automated_45export_45configsbnRUzmX_45U0jaM5CzxB63d_4508WqZdX5oPk_459fsaJLFikMeta } from "/opt/buildhome/repo/pages/invoicing/settings/automated-export-configs.vue?macro=true";
import { default as settingsKXXUn6ECp4IKIj0gnjzs8yDup4JYCh2lliY8LMtXaukMeta } from "/opt/buildhome/repo/pages/invoicing/settings.vue?macro=true";
import { default as worksitesImFYaiiF4uK76VGUCcuDUJUYRTgbJmlpVSdfwm98FegMeta } from "/opt/buildhome/repo/pages/worksite/worksites.vue?macro=true";
import { default as indexESkRMPFoJWesrQX7HdKCkyVusvGFi8E4uoLH87JcrkUMeta } from "/opt/buildhome/repo/pages/auth/register/index.vue?macro=true";
import { default as reset_45passwordVxuQyUMBySjF4TTBevFLXice7Yi56zw2bZYHEWNi0ewMeta } from "/opt/buildhome/repo/pages/auth/reset-password.vue?macro=true";
import { default as index8fZjHwRQUYF7UAvNeiSb9BOiQOz6eHXeXx8BOnapJJsMeta } from "/opt/buildhome/repo/pages/crm/lead/[id]/index.vue?macro=true";
import { default as _91id_93_2BE9vcbt7r2VcXnVeBFgb3jDhvbBq0hQTyK14miqk0Meta } from "/opt/buildhome/repo/pages/settings/users/[id].vue?macro=true";
import { default as forgot_45passwordioOe1ufgzy0WtUzM0b2zzf2yOkTqOjLSGnCYiaXaYXIMeta } from "/opt/buildhome/repo/pages/auth/forgot-password.vue?macro=true";
import { default as statisticsT0vGUo_HHvx5sqQKvr8jpmvOkPRNj_45NiCb4qAvMoaDsMeta } from "/opt/buildhome/repo/pages/invoicing/statistics.vue?macro=true";
import { default as logszr1qLTecbcwmc_458XLzKdGI7k3MXAMBCNxCSg593SDGEMeta } from "/opt/buildhome/repo/pages/settings/outbox/logs.vue?macro=true";
import { default as indexRfvRcwC4r8y6YKVuaY8WIpW2Lmjz2bNyhoJZxIC_45_45dgMeta } from "/opt/buildhome/repo/pages/settings/users/index.vue?macro=true";
import { default as logoa_l_45aTPKyofjvgOAgHdbvFvrsrKns4s1cwKcEbx9P5QMeta } from "/opt/buildhome/repo/pages/settings/company/logo.vue?macro=true";
import { default as indexym0FOqbO7_45Gm_45ynPNdWDRpt7A_lzmfAIZaMFhj97BqMMeta } from "/opt/buildhome/repo/pages/settings/credit/index.vue?macro=true";
import { default as indexKMdpFlOp41sNI3D_LmwNrMZMj3mbkky9bObRMzUfLkUMeta } from "/opt/buildhome/repo/pages/settings/outbox/index.vue?macro=true";
import { default as invite6wI1Rzf6DaYh2dX6BNXNKao30rwj9CGeSTGmrFYnS9gMeta } from "/opt/buildhome/repo/pages/settings/users/invite.vue?macro=true";
import { default as authorizedMSPLmlSH_T0zPAbQyHuxZ2Inp7BgzZtTB32eP3cQbFwMeta } from "/opt/buildhome/repo/pages/bankaccount/authorized.vue?macro=true";
import { default as indexAebgN_tOQ67_45QTgk7cFz15PUJBbsRZRdoQJMDJnoGRAMeta } from "/opt/buildhome/repo/pages/invoicing/quotes/index.vue?macro=true";
import { default as indexpEg76RkCvVNwxKhSMXKXYpjjg6gAlQC6pkBOoetPO_wMeta } from "/opt/buildhome/repo/pages/settings/company/index.vue?macro=true";
import { default as indexBYCWegusfUebMGKT0yMWxacAvHVEVJQSMnamwVFywHgMeta } from "/opt/buildhome/repo/pages/settings/profile/index.vue?macro=true";
import { default as profitabilityq_2WTO77F7rZw1NmkkVivVviuLsU7iSvdovTmhCH2SAMeta } from "/opt/buildhome/repo/pages/worksite/profitability.vue?macro=true";
import { default as index6csWj6FwcvWEWW4Mj1rlSGNIXBYMAxifba6x0s4oJswMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/index.vue?macro=true";
import { default as tasks7DQfuKQWLp6Ykqm8ylYXMwItvp009_SHmt6phVaDXPQMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/tasks.vue?macro=true";
import { default as timelineXZ4C_7tjuR_cneWJiTXphIk0Xswql1AKhQ1GKkXkY_YMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/timeline.vue?macro=true";
import { default as documentsTIkh8L1rKqX3WqxfW4PWA3DKHupKS7HYyRReTsx3TkUMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/documents.vue?macro=true";
import { default as resourcestAh2N37DQ6gsQbsWz_4FbOayLJtXhdO8HiNldzANWu0Meta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/resources.vue?macro=true";
import { default as time_45sheetsXuDMtF6B6mujWzLFSpECl8odnfOzIZlwrmM9erBt7gcMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/time-sheets.vue?macro=true";
import { default as informationsyWObLKur_b6sYc4TSGfDkOJzMi7LuaKkquTFmtwOVIkMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/informations.vue?macro=true";
import { default as profitabilityEFfgkFXHMb20KCtZ4xQPxBZ0kls9HsvOB9tuJt_45Bxt0Meta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/profitability.vue?macro=true";
import { default as index4ZZDVMsrIODiLCl5qrkmOoBUBNX3z2w6QXcdkuY_45lj4Meta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/progress-billings/index.vue?macro=true";
import { default as createDwzsq24HbXtw2olKAFGHdK46przUSlQlXPNcGNyseVYMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/progress-billings/create.vue?macro=true";
import { default as index_45pT_45feDK6ZxBXZJ7CkomNBGjN7yGQnC5c20n_45oH7cMUMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/worksite-closure-reports/index.vue?macro=true";
import { default as editDGPVdPrPtVtZEwMJOnRzht6cx6MBxteY3F_450iOG6T_gMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/progress-billings/[progressBillingId]/edit.vue?macro=true";
import { default as indexb_45rHd1FkNboxedQOmquDkVBAd1pr5LLfhlWjQ0cnLEcMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/progress-billings/[progressBillingId]/index.vue?macro=true";
import { default as indexlw0hOBCTXxsOKpCnj_u7I0YdOCJOQ5HU0Al39Q6elUcMeta } from "/opt/buildhome/repo/pages/worksite/worksite/[id]/worksite-closure-reports/[closureReport]/index.vue?macro=true";
import { default as _91id_93ro76vhHJW4i5bZX2lRtOtpPXl5x_45Ny5S0EHUuDRy7M0Meta } from "/opt/buildhome/repo/pages/worksite/worksite/[id].vue?macro=true";
import { default as pausedXCPFWS6nl11R_45t0MAwlybAeQcqpEUd4nBxcc_45djI9TAMeta } from "/opt/buildhome/repo/pages/auth/tenant/[id]/paused.vue?macro=true";
import { default as authorizingDTB_Ehaf4zbEBNaf5oCRZc9InE4fcDGR8zZRWyVcuQ8Meta } from "/opt/buildhome/repo/pages/bankaccount/authorizing.vue?macro=true";
import { default as _91id_93J3_45bDCmNylLD_459Df7DBPuseJ2ooKevLkS8xTH37Zi7oMeta } from "/opt/buildhome/repo/pages/invoicing/contacts/[id].vue?macro=true";
import { default as create810bVPZ5LQdgYQ1X49sNJknW4iTYX3dmHa4SF1iq274Meta } from "/opt/buildhome/repo/pages/invoicing/quotes/create.vue?macro=true";
import { default as indexnJSkgOzcBztPHsL7owvg6Og8zP65PBDHCr_45sRmUukVgMeta } from "/opt/buildhome/repo/pages/settings/invoices/index.vue?macro=true";
import { default as avatarVUWQgb8N5yyH40fRNw3ceHFjiQc_451KoGDPB8rANn1F0Meta } from "/opt/buildhome/repo/pages/settings/profile/avatar.vue?macro=true";
import { default as indexZF8M0MgEOz6tieLHYd4KmJKzUSFybbWdcTrVqqaSCJsMeta } from "/opt/buildhome/repo/pages/invoicing/contacts/index.vue?macro=true";
import { default as indexznauNHSLSzVjDL71nT_45CSDmwSfOHJufrQe9MKOIr41QMeta } from "/opt/buildhome/repo/pages/invoicing/expenses/index.vue?macro=true";
import { default as indexAyDBkuZzeaiC9A1l9nuK7_beaunGxB6vQuHLnceQLnIMeta } from "/opt/buildhome/repo/pages/invoicing/invoices/index.vue?macro=true";
import { default as settingsRH5ecPbxQIgvRoEovXAIeEM7Uf9VlPK9z1zCviVHi5gMeta } from "/opt/buildhome/repo/pages/settings/outbox/settings.vue?macro=true";
import { default as inactiveYp6R3EAwh7KMTaxkgh8Lfyr8WbkR_b6PH0TgG_45OiHWQMeta } from "/opt/buildhome/repo/pages/auth/tenant/[id]/inactive.vue?macro=true";
import { default as createE8zkV5xxSZ_45aPY2_HSkyNi7jqOpww0wwHyn8RBCJEyQMeta } from "/opt/buildhome/repo/pages/invoicing/expenses/create.vue?macro=true";
import { default as indexdyqGXVe6YRSQq3W0frM2CTGeWlYKiXrqzK_45GvafFvxUMeta } from "/opt/buildhome/repo/pages/invoicing/inventory/index.vue?macro=true";
import { default as createN1HEA8td4wL7ShmRYTCqIvC8ePu4t8_45pRyf_U6sb_SQMeta } from "/opt/buildhome/repo/pages/invoicing/invoices/create.vue?macro=true";
import { default as passwordHCE5whPqUxEIkx8mRBhWBzIUE1Hy4eK9VlZdS194lqsMeta } from "/opt/buildhome/repo/pages/settings/profile/password.vue?macro=true";
import { default as cancelledE5DBeUHy2dCyRV3VhPEIs0q3o6ejTwykQd6mvBmNpl4Meta } from "/opt/buildhome/repo/pages/auth/tenant/[id]/cancelled.vue?macro=true";
import { default as editibvjV_a2rteGgm4e5ybrHNOan2TdVbi9dwzfvMN3TzYMeta } from "/opt/buildhome/repo/pages/invoicing/quotes/[id]/edit.vue?macro=true";
import { default as sendQ0sI5kNCxVHfYgdRFm1AWRkTz5PWyK5OkW4pSxiinbgMeta } from "/opt/buildhome/repo/pages/invoicing/quotes/[id]/send.vue?macro=true";
import { default as planvay5_7gUSlhDCqf2O8oBjNFuOdN7zSxZCT5761xXaHsMeta } from "/opt/buildhome/repo/pages/settings/subscription/plan.vue?macro=true";
import { default as indexQlPwbIE7f2LbU64rC8N_454pGsCOXK89RoucFiTH0ocgAMeta } from "/opt/buildhome/repo/pages/auth/login/magic-link/index.vue?macro=true";
import { default as indexb94LVe_OedNnzL483eJckUCZKV4R6Gb80ieuruOUOc0Meta } from "/opt/buildhome/repo/pages/invoicing/order-slips/index.vue?macro=true";
import { default as indexA23ZruZdjPrQDe5AcY80XR0KaeEqShJMutc_45R_hxBTIMeta } from "/opt/buildhome/repo/pages/organization/calendar/index.vue?macro=true";
import { default as indexbuTIo8ykwdyMjSGceulT_5tkfbpnsU8ZdpzWbwXpKc8Meta } from "/opt/buildhome/repo/pages/organization/planning/index.vue?macro=true";
import { default as indexOVBQsRilev0NR6hJQgCkaOPywjBwHtMzhWJfLJdJnWoMeta } from "/opt/buildhome/repo/pages/settings/subscription/index.vue?macro=true";
import { default as trial3w6UwQAqSXUgpW0PiXtAHsNZ0_4b6Wr46VjACLwpyKAMeta } from "/opt/buildhome/repo/pages/settings/subscription/trial.vue?macro=true";
import { default as indexBlY_hwtenztUvOdjJ_45Uft3TunP7k4Vk_IVhjc2dxJMgMeta } from "/opt/buildhome/repo/pages/invoicing/credit-notes/index.vue?macro=true";
import { default as edit9M1ZDWwRut5YmNl41CRDxD1_JLbUnPAaBQ6aAi9eu2wMeta } from "/opt/buildhome/repo/pages/invoicing/expenses/[id]/edit.vue?macro=true";
import { default as productsm4vgWehs8I_LLvgYHYHrCRtrVLhcQaeKr3a2XT4vuZ8Meta } from "/opt/buildhome/repo/pages/invoicing/inventory/products.vue?macro=true";
import { default as editUvqkJZRSafMf3xoqpW85xLIWoUw5mIuxOa0vAfFuKlgMeta } from "/opt/buildhome/repo/pages/invoicing/invoices/[id]/edit.vue?macro=true";
import { default as sendcCbrXwQmWN1Qf4yuhyERRYNm_45s3jFTKFeUWKzY1DHWoMeta } from "/opt/buildhome/repo/pages/invoicing/invoices/[id]/send.vue?macro=true";
import { default as createPmI7dAUSZx52e7bpU_aUdkzZn6eP2H6tF4wo2ThwjsgMeta } from "/opt/buildhome/repo/pages/invoicing/order-slips/create.vue?macro=true";
import { default as indexTI2fVK_k07nXFHLqNyYcA8xglO9v9weQ5DLeadLNMsQMeta } from "/opt/buildhome/repo/pages/organization/timesheet/index.vue?macro=true";
import { default as creategHYiq0Qi_45aJzccP2aWFOw0pV5qR7U8k5b_458xjcZlKWgMeta } from "/opt/buildhome/repo/pages/invoicing/credit-notes/create.vue?macro=true";
import { default as indexiwP4MH_HxZ3s5NmrbZp8XvxaIv1PQFnrUAhp81ghD60Meta } from "/opt/buildhome/repo/pages/invoicing/expenses/[id]/index.vue?macro=true";
import { default as vat_45ratesP90VI7AIXiwyuDrsVFlswRsd3t_1t1aytO9GkaXUd7AMeta } from "/opt/buildhome/repo/pages/invoicing/inventory/vat-rates.vue?macro=true";
import { default as informationsa5xZpWhN_45tlL4GFDsJvcbUC55J55SdArdYRgW55OAToMeta } from "/opt/buildhome/repo/pages/settings/company/informations.vue?macro=true";
import { default as informationsLzfhU6vrzfWWNzubdfzp6zx0sRlTzYR2V4_r2An9klUMeta } from "/opt/buildhome/repo/pages/settings/profile/informations.vue?macro=true";
import { default as creditsltFTLMPZMn400ly05iZZX4yLElm37kO2Kfa2JnSwpugMeta } from "/opt/buildhome/repo/pages/settings/subscription/credits.vue?macro=true";
import { default as validateYsL8gAybves0nm3G5l9tD19leWkszovcBzEvL2mQx_45AMeta } from "/opt/buildhome/repo/pages/auth/login/magic-link/validate.vue?macro=true";
import { default as index16Sv4tlBuGEdX3IJ4fzdMRvnuAFxhdNjGi6vvRr5OHkMeta } from "/opt/buildhome/repo/pages/invoicing/delivery-slips/index.vue?macro=true";
import { default as self_45billedNlYFpeIreWNE9BGxmwE_45O62KTLXBDYFQGR_TRN_5eO8Meta } from "/opt/buildhome/repo/pages/invoicing/invoices/self-billed.vue?macro=true";
import { default as indexsiKC1h7tZXlQGho0yPPXHsDApw_hgSTflHrKYFdE2FkMeta } from "/opt/buildhome/repo/pages/bankaccount/bank-accounts/index.vue?macro=true";
import { default as createbV8pAoMPy_45aO1qsx_45J0L2W6XyZN0z6lrnv_45HkkTKW8UMeta } from "/opt/buildhome/repo/pages/invoicing/delivery-slips/create.vue?macro=true";
import { default as edit4c06enu86bEHUs9IqjFsO8lbZJS_45iuhmiSSbwJAKjLoMeta } from "/opt/buildhome/repo/pages/invoicing/order-slips/[id]/edit.vue?macro=true";
import { default as send9L_45n9_45z3kddyaSIQtIgsPzP157TPv2HjrFMsfVvjr3sMeta } from "/opt/buildhome/repo/pages/invoicing/order-slips/[id]/send.vue?macro=true";
import { default as index4LoQznC7RP0DOZY_qLi1yM4Xg_BNqmxi3Te58z5o5VkMeta } from "/opt/buildhome/repo/pages/settings/terms-of-service/index.vue?macro=true";
import { default as edit0DIXFLY0eDEGX3JEt1V9C5g8q43Mf58miSdbUcYY0bkMeta } from "/opt/buildhome/repo/pages/invoicing/credit-notes/[id]/edit.vue?macro=true";
import { default as sendI9H_UMKPsi3fcqVsUM06TDc6HbWrXfdnoYKUtIzsxhEMeta } from "/opt/buildhome/repo/pages/invoicing/credit-notes/[id]/send.vue?macro=true";
import { default as time_45activities_45S9F3SanhKBLT2lA1nazkj0UGPMBk1ghvtatT0wb_45jUMeta } from "/opt/buildhome/repo/pages/settings/company/time-activities.vue?macro=true";
import { default as worksite_45closure_45reportJJalxtC0Mwo9wu3r9VMtrvzwPG_45l_i8RUhPfx_45jPYFAMeta } from "/opt/buildhome/repo/pages/worksite/worksite-closure-report.vue?macro=true";
import { default as product_45unitsXY5quDUN5IWrQMR49VG_FRQgou7a45uORWkf5csyBVAMeta } from "/opt/buildhome/repo/pages/invoicing/inventory/product-units.vue?macro=true";
import { default as users_45spotsWayCktQuXA8A1af_VXLsrWFs8WMq5Af79WoN5PFamQUMeta } from "/opt/buildhome/repo/pages/settings/subscription/users-spots.vue?macro=true";
import { default as editb_ZDXn0c9C3uXCNwBgNjaC1_iaqU8rt2SuGUEjscECoMeta } from "/opt/buildhome/repo/pages/invoicing/delivery-slips/[id]/edit.vue?macro=true";
import { default as sendEERkGoZmtcfVWsf3HM0H68_45eDis4ZoQPdWwvbKPH5yMMeta } from "/opt/buildhome/repo/pages/invoicing/delivery-slips/[id]/send.vue?macro=true";
import { default as worksite_45progress_45billingsYgx4xSmqwB4S5q2eRspTGR8k0zg8TOzacwXmxMZyYigMeta } from "/opt/buildhome/repo/pages/worksite/worksite-progress-billings.vue?macro=true";
import { default as product_45sections1ZpnRj3DDgClE8taHKZBOKZr4qh591oYkJN4YB6YLgkMeta } from "/opt/buildhome/repo/pages/invoicing/inventory/product-sections.vue?macro=true";
import { default as contact_45informationsQSjFz7wAZqVOyvwZ6ddmJ7ep2PGy56WBSaiYEZ_45GR0IMeta } from "/opt/buildhome/repo/pages/settings/company/contact-informations.vue?macro=true";
import { default as _91claimToken_93aYdjr8qWFbJzvVJ5hAMuKnCNGqvsrChJ9JeFJaCY9bEMeta } from "/opt/buildhome/repo/pages/claim/[temporaryTenantId]/[claimToken].vue?macro=true";
import { default as successVQgehxQYaB1_45spb8l9m9THadZT2tE4CTJAeznHMpBfQMeta } from "/opt/buildhome/repo/pages/configurators/[configuratorId]/success.vue?macro=true";
import { default as product_45categoriesOHEblB9nD4h_5UOpO8PFjVmJJVz_kdxCehC851yvZ1gMeta } from "/opt/buildhome/repo/pages/invoicing/inventory/product-categories.vue?macro=true";
import { default as _91bankAccount_937N8Q1mPU0_4526WvVbStbS1Yc33v93GzqcjbXFylaqvtwMeta } from "/opt/buildhome/repo/pages/bankaccount/bank-accounts/[bankAccount].vue?macro=true";
import { default as indexwuboXrd_45ubYhTowTdaHcagBnXTnEnrWkeExzmpnDPgUMeta } from "/opt/buildhome/repo/pages/worksite/worksite-closure-reports/index.vue?macro=true";
import { default as indexJu466xKCCYEfvh0I8eqk9KvWeFwXkyMMZpEPOleqRhkMeta } from "/opt/buildhome/repo/pages/configurators/[configuratorId]/groups/[groupId]/steps/[stepId]/index.vue?macro=true";
import { default as auth_45switchoYGc9ajVdkv6UBaEsRqwgW1YLR7PG7802uUuRZv7CIcMeta } from "/opt/buildhome/repo/node_modules/@deegital/nuxt-trustup-io-app-switch/dist/runtime/pages/auth-switch?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: messages3maGN6BtljYJ_4amUi4sXfRWex8Foh_4597x3RpUnzsHsMeta?.name,
    path: "/messages",
    component: () => import("/opt/buildhome/repo/pages/messages.vue"),
    children: [
  {
    name: "messages",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/messages/index.vue")
  },
  {
    name: "messages-guid",
    path: ":guid()",
    component: () => import("/opt/buildhome/repo/pages/messages/[guid].vue")
  }
]
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/opt/buildhome/repo/pages/[...slug].vue")
  },
  {
    name: "crm-leads",
    path: "/crm/leads",
    component: () => import("/opt/buildhome/repo/pages/crm/leads.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/opt/buildhome/repo/pages/dashboard.vue")
  },
  {
    name: "task",
    path: "/task",
    component: () => import("/opt/buildhome/repo/pages/task/index.vue")
  },
  {
    name: visibilityZhXWbhT8e55VG__45P2ZF3n_mg6sRTHSDf3Q8Z1cOE8aEMeta?.name,
    path: "/visibility",
    component: () => import("/opt/buildhome/repo/pages/visibility.vue"),
    children: [
  {
    name: "visibility",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/visibility/index.vue")
  },
  {
    name: "visibility-my-page",
    path: "my-page",
    component: () => import("/opt/buildhome/repo/pages/visibility/my-page.vue")
  },
  {
    name: "visibility-reviews",
    path: "reviews",
    component: () => import("/opt/buildhome/repo/pages/visibility/reviews.vue")
  },
  {
    name: "visibility-sectors",
    path: "sectors",
    component: () => import("/opt/buildhome/repo/pages/visibility/sectors.vue")
  },
  {
    name: "visibility-statistics",
    path: "statistics",
    component: () => import("/opt/buildhome/repo/pages/visibility/statistics.vue")
  },
  {
    name: "visibility-photos",
    path: "photos",
    component: () => import("/opt/buildhome/repo/pages/visibility/photos/index.vue")
  },
  {
    name: "visibility-photos-create",
    path: "photos/create",
    component: () => import("/opt/buildhome/repo/pages/visibility/photos/create.vue")
  },
  {
    name: "visibility-photos-albumId",
    path: "photos/:albumId()",
    component: () => import("/opt/buildhome/repo/pages/visibility/photos/[albumId].vue")
  }
]
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    component: () => import("/opt/buildhome/repo/pages/auth/logout.vue")
  },
  {
    name: "contacts-id",
    path: "/contacts/:id()",
    component: () => import("/opt/buildhome/repo/pages/contacts/[id].vue")
  },
  {
    name: "switch-tenant",
    path: "/switch-tenant",
    meta: switch_45tenantgM0tmPXBKnUjcBjVpSFzrrTuCkTcwSc8o8GgyNIb8OcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/switch-tenant.vue")
  },
  {
    name: "contacts",
    path: "/contacts",
    component: () => import("/opt/buildhome/repo/pages/contacts/index.vue")
  },
  {
    name: "crm-activities",
    path: "/crm/activities",
    component: () => import("/opt/buildhome/repo/pages/crm/activities.vue")
  },
  {
    name: "planning",
    path: "/planning",
    component: () => import("/opt/buildhome/repo/pages/planning/index.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    component: () => import("/opt/buildhome/repo/pages/redirect/index.vue")
  },
  {
    name: "worksite",
    path: "/worksite",
    component: () => import("/opt/buildhome/repo/pages/worksite/index.vue")
  },
  {
    name: "invoicing",
    path: "/invoicing",
    component: () => import("/opt/buildhome/repo/pages/invoicing/index.vue")
  },
  {
    name: "signed-document",
    path: "/signed-document",
    component: () => import("/opt/buildhome/repo/pages/signed-document.vue")
  },
  {
    name: "timesheet",
    path: "/timesheet",
    component: () => import("/opt/buildhome/repo/pages/timesheet/index.vue")
  },
  {
    name: "auth-impersonate",
    path: "/auth/impersonate",
    meta: impersonateuLIcDh3kVFBP2YkKQMGULPrEgRWRI_lnwO0lBxt9RlEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/impersonate.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    meta: indexFICVtqk7yTzTpWZ9NuaoKj_45X5r8ObsEsnjQKwEXgNQcMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/login/index.vue")
  },
  {
    name: "auth-tenant-error",
    path: "/auth/tenant/error",
    meta: errorvAgMiQYAow3TVYSdshmNbyy8S9zqYb4KOSqYzF1_SsIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/tenant/error.vue")
  },
  {
    name: planningum97mRNgeZMXtzEOGZxE_45VZat1vAX9WctBk3_ZvWOJQMeta?.name,
    path: "/worksite/planning",
    component: () => import("/opt/buildhome/repo/pages/worksite/planning.vue"),
    children: [
  {
    name: "worksite-planning",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/worksite/planning/index.vue")
  },
  {
    name: "worksite-planning-worksite",
    path: "worksite",
    component: () => import("/opt/buildhome/repo/pages/worksite/planning/worksite.vue")
  }
]
  },
  {
    name: settingsKXXUn6ECp4IKIj0gnjzs8yDup4JYCh2lliY8LMtXaukMeta?.name,
    path: "/invoicing/settings",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings.vue"),
    children: [
  {
    name: "invoicing-settings",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/index.vue")
  },
  {
    name: "invoicing-settings-peppol",
    path: "peppol",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/peppol.vue")
  },
  {
    name: documentsx5YRiB3yIr3utKcalBqHbidJBsxQDfjFJ4Waglxldw0Meta?.name,
    path: "documents",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/documents.vue"),
    children: [
  {
    name: "invoicing-settings-documents",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/documents/index.vue")
  },
  {
    name: "invoicing-settings-documents-quotes",
    path: "quotes",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/documents/quotes.vue")
  },
  {
    name: "invoicing-settings-documents-invoices",
    path: "invoices",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/documents/invoices.vue")
  },
  {
    name: "invoicing-settings-documents-annex-pdf",
    path: "annex-pdf",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/documents/annex-pdf.vue")
  },
  {
    name: "invoicing-settings-documents-order-slips",
    path: "order-slips",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/documents/order-slips.vue")
  },
  {
    name: "invoicing-settings-documents-credit-notes",
    path: "credit-notes",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/documents/credit-notes.vue")
  },
  {
    name: "invoicing-settings-documents-delivery-slips",
    path: "delivery-slips",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/documents/delivery-slips.vue")
  }
]
  },
  {
    name: "invoicing-settings-templates",
    path: "templates",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/templates.vue")
  },
  {
    name: "invoicing-settings-export",
    path: "export",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/export/index.vue")
  },
  {
    name: "invoicing-settings-import",
    path: "import",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/import/index.vue")
  },
  {
    name: notifications_RN4qi7ta6CwEh_5LDncWgFl32o_WFfiAXn_45YwpCBiUMeta?.name,
    path: "notifications",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/notifications.vue"),
    children: [
  {
    name: "invoicing-settings-notifications",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/notifications/index.vue")
  },
  {
    name: "invoicing-settings-notifications-documents",
    path: "documents",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/notifications/documents.vue")
  },
  {
    name: "invoicing-settings-notifications-payment-reminders",
    path: "payment-reminders",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/notifications/payment-reminders.vue")
  },
  {
    name: "invoicing-settings-notifications-payment-reminder-groups",
    path: "payment-reminder-groups",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/notifications/payment-reminder-groups.vue")
  }
]
  },
  {
    name: "invoicing-settings-export-documents",
    path: "export/documents",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/export/documents.vue")
  },
  {
    name: "invoicing-settings-import-documents",
    path: "import/documents",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/import/documents.vue")
  },
  {
    name: "invoicing-settings-automated-export-configs",
    path: "automated-export-configs",
    component: () => import("/opt/buildhome/repo/pages/invoicing/settings/automated-export-configs.vue")
  }
]
  },
  {
    name: "worksite-worksites",
    path: "/worksite/worksites",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksites.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: indexESkRMPFoJWesrQX7HdKCkyVusvGFi8E4uoLH87JcrkUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/register/index.vue")
  },
  {
    name: "auth-reset-password",
    path: "/auth/reset-password",
    meta: reset_45passwordVxuQyUMBySjF4TTBevFLXice7Yi56zw2bZYHEWNi0ewMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/reset-password.vue")
  },
  {
    name: "crm-lead-id",
    path: "/crm/lead/:id()",
    component: () => import("/opt/buildhome/repo/pages/crm/lead/[id]/index.vue")
  },
  {
    name: "settings-users-id",
    path: "/settings/users/:id()",
    component: () => import("/opt/buildhome/repo/pages/settings/users/[id].vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordioOe1ufgzy0WtUzM0b2zzf2yOkTqOjLSGnCYiaXaYXIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/forgot-password.vue")
  },
  {
    name: "invoicing-statistics",
    path: "/invoicing/statistics",
    component: () => import("/opt/buildhome/repo/pages/invoicing/statistics.vue")
  },
  {
    name: "settings-outbox-logs",
    path: "/settings/outbox/logs",
    component: () => import("/opt/buildhome/repo/pages/settings/outbox/logs.vue")
  },
  {
    name: "settings-users",
    path: "/settings/users",
    component: () => import("/opt/buildhome/repo/pages/settings/users/index.vue")
  },
  {
    name: "settings-company-logo",
    path: "/settings/company/logo",
    component: () => import("/opt/buildhome/repo/pages/settings/company/logo.vue")
  },
  {
    name: "settings-credit",
    path: "/settings/credit",
    component: () => import("/opt/buildhome/repo/pages/settings/credit/index.vue")
  },
  {
    name: "settings-outbox",
    path: "/settings/outbox",
    component: () => import("/opt/buildhome/repo/pages/settings/outbox/index.vue")
  },
  {
    name: "settings-users-invite",
    path: "/settings/users/invite",
    component: () => import("/opt/buildhome/repo/pages/settings/users/invite.vue")
  },
  {
    name: "bankaccount-authorized",
    path: "/bankaccount/authorized",
    component: () => import("/opt/buildhome/repo/pages/bankaccount/authorized.vue")
  },
  {
    name: "invoicing-quotes",
    path: "/invoicing/quotes",
    component: () => import("/opt/buildhome/repo/pages/invoicing/quotes/index.vue")
  },
  {
    name: "settings-company",
    path: "/settings/company",
    component: () => import("/opt/buildhome/repo/pages/settings/company/index.vue")
  },
  {
    name: "settings-profile",
    path: "/settings/profile",
    component: () => import("/opt/buildhome/repo/pages/settings/profile/index.vue")
  },
  {
    name: "worksite-profitability",
    path: "/worksite/profitability",
    component: () => import("/opt/buildhome/repo/pages/worksite/profitability.vue")
  },
  {
    name: _91id_93ro76vhHJW4i5bZX2lRtOtpPXl5x_45Ny5S0EHUuDRy7M0Meta?.name,
    path: "/worksite/worksite/:id()",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id].vue"),
    children: [
  {
    name: "worksite-worksite-id",
    path: "",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/index.vue")
  },
  {
    name: "worksite-worksite-id-tasks",
    path: "tasks",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/tasks.vue")
  },
  {
    name: "worksite-worksite-id-timeline",
    path: "timeline",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/timeline.vue")
  },
  {
    name: "worksite-worksite-id-documents",
    path: "documents",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/documents.vue")
  },
  {
    name: "worksite-worksite-id-resources",
    path: "resources",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/resources.vue")
  },
  {
    name: "worksite-worksite-id-time-sheets",
    path: "time-sheets",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/time-sheets.vue")
  },
  {
    name: "worksite-worksite-id-informations",
    path: "informations",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/informations.vue")
  },
  {
    name: "worksite-worksite-id-profitability",
    path: "profitability",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/profitability.vue")
  },
  {
    name: "worksite-worksite-id-progress-billings",
    path: "progress-billings",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/progress-billings/index.vue")
  },
  {
    name: "worksite-worksite-id-progress-billings-create",
    path: "progress-billings/create",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/progress-billings/create.vue")
  },
  {
    name: "worksite-worksite-id-worksite-closure-reports",
    path: "worksite-closure-reports",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/worksite-closure-reports/index.vue")
  },
  {
    name: "worksite-worksite-id-progress-billings-progressBillingId-edit",
    path: "progress-billings/:progressBillingId()/edit",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/progress-billings/[progressBillingId]/edit.vue")
  },
  {
    name: "worksite-worksite-id-progress-billings-progressBillingId",
    path: "progress-billings/:progressBillingId()",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/progress-billings/[progressBillingId]/index.vue")
  },
  {
    name: "worksite-worksite-id-worksite-closure-reports-closureReport",
    path: "worksite-closure-reports/:closureReport()",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite/[id]/worksite-closure-reports/[closureReport]/index.vue")
  }
]
  },
  {
    name: "auth-tenant-id-paused",
    path: "/auth/tenant/:id()/paused",
    meta: pausedXCPFWS6nl11R_45t0MAwlybAeQcqpEUd4nBxcc_45djI9TAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/tenant/[id]/paused.vue")
  },
  {
    name: "bankaccount-authorizing",
    path: "/bankaccount/authorizing",
    component: () => import("/opt/buildhome/repo/pages/bankaccount/authorizing.vue")
  },
  {
    name: "invoicing-contacts-id",
    path: "/invoicing/contacts/:id()",
    component: () => import("/opt/buildhome/repo/pages/invoicing/contacts/[id].vue")
  },
  {
    name: "invoicing-quotes-create",
    path: "/invoicing/quotes/create",
    component: () => import("/opt/buildhome/repo/pages/invoicing/quotes/create.vue")
  },
  {
    name: "settings-invoices",
    path: "/settings/invoices",
    component: () => import("/opt/buildhome/repo/pages/settings/invoices/index.vue")
  },
  {
    name: "settings-profile-avatar",
    path: "/settings/profile/avatar",
    component: () => import("/opt/buildhome/repo/pages/settings/profile/avatar.vue")
  },
  {
    name: "invoicing-contacts",
    path: "/invoicing/contacts",
    component: () => import("/opt/buildhome/repo/pages/invoicing/contacts/index.vue")
  },
  {
    name: "invoicing-expenses",
    path: "/invoicing/expenses",
    component: () => import("/opt/buildhome/repo/pages/invoicing/expenses/index.vue")
  },
  {
    name: "invoicing-invoices",
    path: "/invoicing/invoices",
    component: () => import("/opt/buildhome/repo/pages/invoicing/invoices/index.vue")
  },
  {
    name: "settings-outbox-settings",
    path: "/settings/outbox/settings",
    component: () => import("/opt/buildhome/repo/pages/settings/outbox/settings.vue")
  },
  {
    name: "auth-tenant-id-inactive",
    path: "/auth/tenant/:id()/inactive",
    meta: inactiveYp6R3EAwh7KMTaxkgh8Lfyr8WbkR_b6PH0TgG_45OiHWQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/tenant/[id]/inactive.vue")
  },
  {
    name: "invoicing-expenses-create",
    path: "/invoicing/expenses/create",
    component: () => import("/opt/buildhome/repo/pages/invoicing/expenses/create.vue")
  },
  {
    name: "invoicing-inventory",
    path: "/invoicing/inventory",
    component: () => import("/opt/buildhome/repo/pages/invoicing/inventory/index.vue")
  },
  {
    name: "invoicing-invoices-create",
    path: "/invoicing/invoices/create",
    component: () => import("/opt/buildhome/repo/pages/invoicing/invoices/create.vue")
  },
  {
    name: "settings-profile-password",
    path: "/settings/profile/password",
    component: () => import("/opt/buildhome/repo/pages/settings/profile/password.vue")
  },
  {
    name: "auth-tenant-id-cancelled",
    path: "/auth/tenant/:id()/cancelled",
    meta: cancelledE5DBeUHy2dCyRV3VhPEIs0q3o6ejTwykQd6mvBmNpl4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/tenant/[id]/cancelled.vue")
  },
  {
    name: "invoicing-quotes-id-edit",
    path: "/invoicing/quotes/:id()/edit",
    component: () => import("/opt/buildhome/repo/pages/invoicing/quotes/[id]/edit.vue")
  },
  {
    name: "invoicing-quotes-id-send",
    path: "/invoicing/quotes/:id()/send",
    meta: sendQ0sI5kNCxVHfYgdRFm1AWRkTz5PWyK5OkW4pSxiinbgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/invoicing/quotes/[id]/send.vue")
  },
  {
    name: "settings-subscription-plan",
    path: "/settings/subscription/plan",
    component: () => import("/opt/buildhome/repo/pages/settings/subscription/plan.vue")
  },
  {
    name: "auth-login-magic-link",
    path: "/auth/login/magic-link",
    meta: indexQlPwbIE7f2LbU64rC8N_454pGsCOXK89RoucFiTH0ocgAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/login/magic-link/index.vue")
  },
  {
    name: "invoicing-order-slips",
    path: "/invoicing/order-slips",
    component: () => import("/opt/buildhome/repo/pages/invoicing/order-slips/index.vue")
  },
  {
    name: "organization-calendar",
    path: "/organization/calendar",
    component: () => import("/opt/buildhome/repo/pages/organization/calendar/index.vue")
  },
  {
    name: "organization-planning",
    path: "/organization/planning",
    component: () => import("/opt/buildhome/repo/pages/organization/planning/index.vue")
  },
  {
    name: "settings-subscription",
    path: "/settings/subscription",
    component: () => import("/opt/buildhome/repo/pages/settings/subscription/index.vue")
  },
  {
    name: "settings-subscription-trial",
    path: "/settings/subscription/trial",
    component: () => import("/opt/buildhome/repo/pages/settings/subscription/trial.vue")
  },
  {
    name: "invoicing-credit-notes",
    path: "/invoicing/credit-notes",
    component: () => import("/opt/buildhome/repo/pages/invoicing/credit-notes/index.vue")
  },
  {
    name: "invoicing-expenses-id-edit",
    path: "/invoicing/expenses/:id()/edit",
    component: () => import("/opt/buildhome/repo/pages/invoicing/expenses/[id]/edit.vue")
  },
  {
    name: "invoicing-inventory-products",
    path: "/invoicing/inventory/products",
    component: () => import("/opt/buildhome/repo/pages/invoicing/inventory/products.vue")
  },
  {
    name: "invoicing-invoices-id-edit",
    path: "/invoicing/invoices/:id()/edit",
    component: () => import("/opt/buildhome/repo/pages/invoicing/invoices/[id]/edit.vue")
  },
  {
    name: "invoicing-invoices-id-send",
    path: "/invoicing/invoices/:id()/send",
    meta: sendcCbrXwQmWN1Qf4yuhyERRYNm_45s3jFTKFeUWKzY1DHWoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/invoicing/invoices/[id]/send.vue")
  },
  {
    name: "invoicing-order-slips-create",
    path: "/invoicing/order-slips/create",
    component: () => import("/opt/buildhome/repo/pages/invoicing/order-slips/create.vue")
  },
  {
    name: "organization-timesheet",
    path: "/organization/timesheet",
    component: () => import("/opt/buildhome/repo/pages/organization/timesheet/index.vue")
  },
  {
    name: "invoicing-credit-notes-create",
    path: "/invoicing/credit-notes/create",
    component: () => import("/opt/buildhome/repo/pages/invoicing/credit-notes/create.vue")
  },
  {
    name: "invoicing-expenses-id",
    path: "/invoicing/expenses/:id()",
    component: () => import("/opt/buildhome/repo/pages/invoicing/expenses/[id]/index.vue")
  },
  {
    name: "invoicing-inventory-vat-rates",
    path: "/invoicing/inventory/vat-rates",
    component: () => import("/opt/buildhome/repo/pages/invoicing/inventory/vat-rates.vue")
  },
  {
    name: "settings-company-informations",
    path: "/settings/company/informations",
    component: () => import("/opt/buildhome/repo/pages/settings/company/informations.vue")
  },
  {
    name: "settings-profile-informations",
    path: "/settings/profile/informations",
    component: () => import("/opt/buildhome/repo/pages/settings/profile/informations.vue")
  },
  {
    name: "settings-subscription-credits",
    path: "/settings/subscription/credits",
    component: () => import("/opt/buildhome/repo/pages/settings/subscription/credits.vue")
  },
  {
    name: "auth-login-magic-link-validate",
    path: "/auth/login/magic-link/validate",
    meta: validateYsL8gAybves0nm3G5l9tD19leWkszovcBzEvL2mQx_45AMeta || {},
    component: () => import("/opt/buildhome/repo/pages/auth/login/magic-link/validate.vue")
  },
  {
    name: "invoicing-delivery-slips",
    path: "/invoicing/delivery-slips",
    component: () => import("/opt/buildhome/repo/pages/invoicing/delivery-slips/index.vue")
  },
  {
    name: "invoicing-invoices-self-billed",
    path: "/invoicing/invoices/self-billed",
    component: () => import("/opt/buildhome/repo/pages/invoicing/invoices/self-billed.vue")
  },
  {
    name: "bankaccount-bank-accounts",
    path: "/bankaccount/bank-accounts",
    component: () => import("/opt/buildhome/repo/pages/bankaccount/bank-accounts/index.vue")
  },
  {
    name: "invoicing-delivery-slips-create",
    path: "/invoicing/delivery-slips/create",
    component: () => import("/opt/buildhome/repo/pages/invoicing/delivery-slips/create.vue")
  },
  {
    name: "invoicing-order-slips-id-edit",
    path: "/invoicing/order-slips/:id()/edit",
    component: () => import("/opt/buildhome/repo/pages/invoicing/order-slips/[id]/edit.vue")
  },
  {
    name: "invoicing-order-slips-id-send",
    path: "/invoicing/order-slips/:id()/send",
    meta: send9L_45n9_45z3kddyaSIQtIgsPzP157TPv2HjrFMsfVvjr3sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/invoicing/order-slips/[id]/send.vue")
  },
  {
    name: "settings-terms-of-service",
    path: "/settings/terms-of-service",
    component: () => import("/opt/buildhome/repo/pages/settings/terms-of-service/index.vue")
  },
  {
    name: "invoicing-credit-notes-id-edit",
    path: "/invoicing/credit-notes/:id()/edit",
    component: () => import("/opt/buildhome/repo/pages/invoicing/credit-notes/[id]/edit.vue")
  },
  {
    name: "invoicing-credit-notes-id-send",
    path: "/invoicing/credit-notes/:id()/send",
    meta: sendI9H_UMKPsi3fcqVsUM06TDc6HbWrXfdnoYKUtIzsxhEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/invoicing/credit-notes/[id]/send.vue")
  },
  {
    name: "settings-company-time-activities",
    path: "/settings/company/time-activities",
    component: () => import("/opt/buildhome/repo/pages/settings/company/time-activities.vue")
  },
  {
    name: "worksite-worksite-closure-report",
    path: "/worksite/worksite-closure-report",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite-closure-report.vue")
  },
  {
    name: "invoicing-inventory-product-units",
    path: "/invoicing/inventory/product-units",
    component: () => import("/opt/buildhome/repo/pages/invoicing/inventory/product-units.vue")
  },
  {
    name: "settings-subscription-users-spots",
    path: "/settings/subscription/users-spots",
    component: () => import("/opt/buildhome/repo/pages/settings/subscription/users-spots.vue")
  },
  {
    name: "invoicing-delivery-slips-id-edit",
    path: "/invoicing/delivery-slips/:id()/edit",
    component: () => import("/opt/buildhome/repo/pages/invoicing/delivery-slips/[id]/edit.vue")
  },
  {
    name: "invoicing-delivery-slips-id-send",
    path: "/invoicing/delivery-slips/:id()/send",
    meta: sendEERkGoZmtcfVWsf3HM0H68_45eDis4ZoQPdWwvbKPH5yMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/invoicing/delivery-slips/[id]/send.vue")
  },
  {
    name: "worksite-worksite-progress-billings",
    path: "/worksite/worksite-progress-billings",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite-progress-billings.vue")
  },
  {
    name: "invoicing-inventory-product-sections",
    path: "/invoicing/inventory/product-sections",
    component: () => import("/opt/buildhome/repo/pages/invoicing/inventory/product-sections.vue")
  },
  {
    name: "settings-company-contact-informations",
    path: "/settings/company/contact-informations",
    component: () => import("/opt/buildhome/repo/pages/settings/company/contact-informations.vue")
  },
  {
    name: "claim-temporaryTenantId-claimToken",
    path: "/claim/:temporaryTenantId()/:claimToken()",
    meta: _91claimToken_93aYdjr8qWFbJzvVJ5hAMuKnCNGqvsrChJ9JeFJaCY9bEMeta || {},
    component: () => import("/opt/buildhome/repo/pages/claim/[temporaryTenantId]/[claimToken].vue")
  },
  {
    name: "configurators-configuratorId-success",
    path: "/configurators/:configuratorId()/success",
    meta: successVQgehxQYaB1_45spb8l9m9THadZT2tE4CTJAeznHMpBfQMeta || {},
    component: () => import("/opt/buildhome/repo/pages/configurators/[configuratorId]/success.vue")
  },
  {
    name: "invoicing-inventory-product-categories",
    path: "/invoicing/inventory/product-categories",
    component: () => import("/opt/buildhome/repo/pages/invoicing/inventory/product-categories.vue")
  },
  {
    name: "bankaccount-bank-accounts-bankAccount",
    path: "/bankaccount/bank-accounts/:bankAccount()",
    component: () => import("/opt/buildhome/repo/pages/bankaccount/bank-accounts/[bankAccount].vue")
  },
  {
    name: "worksite-worksite-closure-reports",
    path: "/worksite/worksite-closure-reports",
    component: () => import("/opt/buildhome/repo/pages/worksite/worksite-closure-reports/index.vue")
  },
  {
    name: "configurators-configuratorId-groups-groupId-steps-stepId",
    path: "/configurators/:configuratorId()/groups/:groupId()/steps/:stepId()",
    meta: indexJu466xKCCYEfvh0I8eqk9KvWeFwXkyMMZpEPOleqRhkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/configurators/[configuratorId]/groups/[groupId]/steps/[stepId]/index.vue")
  },
  {
    name: "auth-switch",
    path: "/auth/switch",
    component: () => import("/opt/buildhome/repo/node_modules/@deegital/nuxt-trustup-io-app-switch/dist/runtime/pages/auth-switch")
  }
]